import { render, staticRenderFns } from "./QuestionIndexView.vue?vue&type=template&id=0c3a8e1a&scoped=true"
import script from "./QuestionIndexView.vue?vue&type=script&lang=js"
export * from "./QuestionIndexView.vue?vue&type=script&lang=js"
import style0 from "./QuestionIndexView.vue?vue&type=style&index=0&id=0c3a8e1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3a8e1a",
  null
  
)

export default component.exports